module.exports = __webpack_public_path__ + "img/base_hiver_luge.85c0f290.svg";